import { render, staticRenderFns } from "./tabSeBookingUICustomLayout.vue?vue&type=template&id=174aac18&"
import script from "./tabSeBookingUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabSeBookingUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('174aac18')) {
      api.createRecord('174aac18', component.options)
    } else {
      api.reload('174aac18', component.options)
    }
    module.hot.accept("./tabSeBookingUICustomLayout.vue?vue&type=template&id=174aac18&", function () {
      api.rerender('174aac18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/components/remoteBooking/tabs/tabSeBookingUICustomLayout.vue"
export default component.exports